module.exports = __webpack_public_path__ + "f68ce276380624f9d4baff54ab70efef.bg_main_mid.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/whyUsSection/assets/bg_main_mid.jpg
// module id = Pvwk
// module chunks = 0